import styled from 'styled-components';

const RowTooltip = styled.div``;

const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  margin: 10px 0px 10px 0px;
  position: relative;
  & ${RowTooltip} {
    display: none;
  }
  &:hover ${RowTooltip} {
    display: block;
  }
`;

const RowKey = styled.div`
  text-align: left;
  p {
    margin: 0;
  }
`;

const RowValue = styled.div`
  position: relative;
  text-align: right;
`;

export { Row, RowKey, RowTooltip, RowValue };
